module.exports = __webpack_public_path__ + "static/media/bg-green.14cf1deb.svg";